export const Functions = {
  create: false,
  delete: true,
  detail: true,
  search: true
};
export const PageName = '国庆活动记录';